import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  id: "page-login"
};
const _hoisted_2 = {
  key: 1,
  id: "page-login",
  style: {
    height: '457px !important',
    minHeight: '457px !important'
  }
};
import { useIndexPageStyle } from '@/composable/useIndex';
export default /*#__PURE__*/_defineComponent({
  __name: 'login',

  setup(__props) {
    const pageStyle = useIndexPageStyle();
    return (_ctx, _cache) => {
      const _component_up_header = _resolveComponent("up-header");

      const _component_page_login = _resolveComponent("page-login");

      const _component_up_supported_by = _resolveComponent("up-supported-by");

      return !_unref(pageStyle).isDeheroEnv.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_up_header, {
        "hide-back": ""
      }), _createVNode(_component_page_login), _createVNode(_component_up_supported_by)])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_page_login)]));
    };
  }

});